import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const Map = observer(class Map extends React.Component {
  componentWillMount() {
    let hideMap = true;

    if(this.props.locationSet) {
      hideMap = false;
    }

    this.state = {
      mapRendered: false,
      hideMap
    }
  }

  componentDidMount() {
    if(!this.props.store.LocationStore.locationSid) {
      this.setState({
        mapRendered: true
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(this.state.hideMap && !nextState.hideMap) {
      return true;
    }

    if(this.state.mapRendered) {
      return false;
    } else {
      return true;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // If the update is due to a location being
    // selected, stop what we’re doing
    if(!this.state.hideMap && prevState.hideMap) {
      return true;
    }

    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    let google = window.google;
    let map;
    const _this = this;

    function initMap() {
      map = new google.maps.Map(document.getElementById('map'), {
        center: _this.props.center,
        zoom: _this.props.zoom,
        streetViewControl: false,
        mapTypeControl: false,
        scrollwheel: false,
        clickableIcons: false,
        fullscreenControl: false
      });

      let name = null;
      let address1 = null;
      let address2 = null;
      let city = null;
      let region = null;
      let country = null;
      let postalCode = null;
      let lat = null;
      let lng = null;
      let lastPosition = null;

      // Custom marker
      const pin = {
        anchor: new google.maps.Point(10, 30),
        path: 'm14.955742,10.044257q0,-2.051987 -1.451878,-3.503865t-3.503865,-1.451878t-3.503865,1.451878t-1.451878,3.503865t1.451878,3.503866t3.503865,1.451878t3.503865,-1.451878t1.451878,-3.503866zm4.955743,0q0,2.110063 -0.638826,3.465149l-7.046447,14.98338q-0.309734,0.638826 -0.919523,1.006635t-1.30669,0.367809t-1.30669,-0.367809t-0.900164,-1.006635l-7.065806,-14.98338q-0.638826,-1.355086 -0.638826,-3.465149q0,-4.103975 2.903756,-7.007731t7.007731,-2.903756t7.007731,2.903756t2.903756,7.007731z',
        fillColor: '#9d80d8',
        fillOpacity: 1,
        strokeColor: '#7f59cc',
        strokeWeight: 1,
        scale: 1.25
      }

      // Create marker
      var marker = new google.maps.Marker({
        map: map,
        icon: pin,
        draggable: true
      });

      // Create drag radius
      var radius = new google.maps.Circle({
        // strokeColor: '#ff0000',
        strokeOpacity: 0,
        // strokeWeight: 1,
        clickable: false,
        fillOpacity: 0,
        map: map,
        radius: 100
      });

      // If a center is provided, drop the marker and the radius
      if(_this.props.dropPin) {
        marker.setPosition(_this.props.center);
        radius.setCenter(_this.props.center);
      }

      marker.addListener('dragend', function() {
        const markerPosition = marker.getPosition();
        lat = markerPosition.lat();
        lng = markerPosition.lng();

        _this.props.setLocation(name, address1, address2, city, region, country, postalCode, lat, lng, true);
      });

      // Limit marker drag to location bounds
      marker.addListener('drag', function() {
        const position = marker.getPosition();
        const bounds = radius.getBounds();
        if(bounds.contains(position)) {
          lastPosition = position;
        } else {
          marker.setPosition(lastPosition);
        }
      })

      // Places autocomplete
      const input = document.querySelector('#map-search');

      if(input) {
        const options = {
          types: [],
          fields: ['address_components', 'name', 'geometry.location', 'place_id', 'formatted_address']
        }

        let autocomplete = new google.maps.places.Autocomplete(input, options);

        // Bind the map’s bounds to the autocomplete object

        autocomplete.bindTo('bounds', map);

        input.addEventListener('keydown', function(e) {
          if (e.keyCode === 13) {
            e.preventDefault();
          }
        });

        autocomplete.addListener('place_changed', function() {
          marker.setVisible(false);
          let place = autocomplete.getPlace();

          // Reset address variables
          name = null;
          address1 = null;
          address2 = null;
          city = null;
          region = null;
          country = null;
          postalCode = null;
          lat = null;
          lng = null;

          if(!place.geometry) {
            // The user entered the name of a place that wasn’t suggested
            // and pressed the Enter key, or the request failed
            // window.alert(`No details available for “${place.name}”`);
            let suggestions = document.querySelector('.pac-container');

            setTimeout(function(){
              suggestions.style.display = 'block';
            });

            const dialogContent = translation.no_place;

            _this.props.store.SessionStore.showDialog(dialogContent);

            input.value = '';

            return;
          } else {
            // Set the name
            name = place.name;

            // Loop through address components to get data
            for(let i = 0; i < place.address_components.length; i++) {
              // Address 1 number
              if(place.address_components[i].types.indexOf('street_number') > -1) {
                address1 = place.address_components[i].short_name;
              }

              // Address 1 street
              if(place.address_components[i].types.indexOf('route') > -1) {
                if(address1) {
                  address1 += ' ' + place.address_components[i].short_name;
                } else {
                  address1 = place.address_components[i].short_name;
                }
              }

              // Address 2
              if(place.address_components[i].types.indexOf('subpremise') > -1) {
                address2 = place.address_components[i].short_name;
              }

              // City
              if(place.address_components[i].types.indexOf('locality') > -1) {
                city = place.address_components[i].short_name;
              } else if(place.address_components[i].types.indexOf('sublocality') > -1) {
                city = place.address_components[i].short_name;
              }

              // Region
              if(place.address_components[i].types.indexOf('administrative_area_level_1') > -1) {
                region = place.address_components[i].short_name;
              }

              // Country
              if(place.address_components[i].types.indexOf('country') > -1) {
                country = place.address_components[i].long_name;
              }

              // Postal code
              if(place.address_components[i].types.indexOf('postal_code') > -1) {
                postalCode = place.address_components[i].short_name;
              }
            }

            // Check if address components contained a city
            // and alert the user if it didn’t
            if(!city) {
              input.value = '';
              const dialogContent = translation.city_required;
              SessionStore.showDialog(dialogContent);
              return false;
            }

            // Check if address components contained a street address
            // and parse the formatted address if it didn’t
            if(!address1) {
              let addr_arr = place.formatted_address.split(',');

              if(addr_arr.length > 3) {
                address1 = addr_arr[0];

                if(addr_arr.length > 4) {
                  address2 = addr_arr[1].replace(' ', '');
                }
              }
            }

            // If we’re requiring a street address, make sure one
            // has been found
            if(_this.props.requireAddress && !address1) {
              input.value = '';
              const dialogContent = translation.address_required;
              SessionStore.showDialog(dialogContent);
              return false;
            }

            lat = place.geometry.location.lat();
            lng = place.geometry.location.lng();

            _this.props.setLocation(name, address1, address2, city, region, country, postalCode, lat, lng)
          }

          // Move the map
          map.setCenter(place.geometry.location);
          map.setZoom(17);

          _this.showMap();

          // Set marker drag bounds
          radius.setCenter(place.geometry.location);

          // bounds = new google.maps.LatLngBounds();
          // console.log(bounds);

          // Drop a marker
          marker.setPosition(place.geometry.location);
          marker.setVisible(true);
        });
      }
    }

    // If it’s a new location, initialize the map
    if(this.props.store.LocationStore.renderMap && !this.props.store.LocationStore.locationSid) {
      initMap();
    }

    // If it’s an exisiting location, wait for data and then initialize the map
    if(this.props.store.LocationStore.locationSid && this.props.store.LocationStore.locationData.name) {
      this.setState({
        mapRendered: true
      });

      if(!_this.state.mapRendered) {
        initMap();
      }
    }
  }

  showMap() {
    this.setState({
      hideMap: false
    });
  }

  render() {
    const { translation } = this.props;

    return(
      <div className="map">
        <div className="map__search">
          <label className="meta" htmlFor="map-search">{translation.location.label}</label>
          {!this.props.locationSid && !this.props.default &&
            <input
              type="text"
              id="map-search"
              placeholder={translation.location.helper}
              required
              aria-required="true"
            />
          }
          {this.props.default &&
            <input
              type="text"
              id="map-search"
              placeholder={translation.location.helper}
              defaultValue={this.props.default}
              required
              aria-required="true"
            />
          }
        </div>

        <div className="location__map-wrap">
          <div id="map" className="location__map"></div>

          {this.state.hideMap &&
            <div className="location__map-overlay">
              <div className="copy">
                <span className="yes-results">{translation.helper.heading}</span>

                <p>{translation.helper.body}</p>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
})

export default translate('Map')(Map);



// WEBPACK FOOTER //
// ./src/app/components/Map/Map.js